/**
 * Format a slot identifier (e.g. "8-9", "14-15") into a friendly
 * AM/PM range like "8:00 AM - 9:00 AM". Falls back to the raw value when
 * the input isn't a recognizable numeric range.
 */
export function formatSlot(slotId) {
  if (!slotId) return "";
  const s = String(slotId).trim();
  // Only process pure numeric ranges like "8-9" or "14-15"
  if (!/^\d+-\d+$/.test(s)) return s;
  const parts = s.split("-");
  if (parts.length !== 2) return s;
  const a = parseInt(parts[0], 10);
  const b = parseInt(parts[1], 10);
  if (Number.isNaN(a) || Number.isNaN(b)) return s;
  const fmt = (h) => {
    const suffix = h < 12 || h === 24 ? "AM" : "PM";
    let h12 = h % 12;
    if (h12 === 0) h12 = 12;
    return `${h12}:00 ${suffix}`;
  };
  return `${fmt(a)} - ${fmt(b)}`;
}
